module.exports = __webpack_public_path__ + "img/1635580732015928.0c431a56.jpg";